import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import type { ModalProps } from '@/components/providers/ModalProvider/ModalProvider';
import { Button } from '@/components/shadcn/button';
import { Input } from '@/components/shadcn/input';

type Props = ModalProps & {
  loginUrl: string;
};

export default function ManualLoginModal({ loginUrl, onClose }: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex w-80 max-w-full flex-col gap-4 p-4">
      <div className="flex items-start justify-between gap-2">
        <div className="flex min-w-0 flex-col gap-1 break-words">
          <p className="font-medium">{t('AUTH_LOGIN_MANUAL_TITLE')}</p>

          <p className="text-muted-foreground text-sm">
            {t('AUTH_LOGIN_MANUAL_DESCRIPTION')}
          </p>
        </div>

        <Button variant="ghost" size="icon-xs" onClick={onClose}>
          <X />
        </Button>
      </div>

      <Input
        readOnly
        value={loginUrl}
        onFocus={(event) => event.currentTarget.select()}
        className="text-xs"
      />
    </div>
  );
}
